export class EditFloorShapeAction {

  public readonly oldPoints: Array<any>;
  public readonly floorId: number;
  public readonly newPoints: Array<any>;

  constructor(
    oldPoints: Array<any>,
    newPoints: Array<any>,
    floorId: number
  ) {
    this.oldPoints = oldPoints;
    this.floorId = floorId;
    this.newPoints = newPoints;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/EditFloorShapeAction.ts